import logEvent from '../logEvent';

function logEventSchoolExplorer(code, data) {
  logEvent(`SEPR-${code}`, data);
}

export function logEventSchoolExplorerStart() {
  logEventSchoolExplorer('01');
}

export function logEventSchoolExplorerSelectCareer(data) {
  logEventSchoolExplorer('02', data);
}

export function logEventSchoolExplorerCareerDetails(data) {
  logEventSchoolExplorer('03', data);
}

export function logEventSchoolExplorerMap(data) {
  logEventSchoolExplorer('04', data);
}

export function logEventSchoolExplorerSelectSchool(data) {
  logEventSchoolExplorer('05', data);
}

export function logEventSchoolExplorerSchoolPrograms(data) {
  logEventSchoolExplorer('06', data);
}

export function logEventSchoolExplorerRating(data) {
  logEventSchoolExplorer('07', data);
}

export function logEventSchoolExplorerProgramDetails(data) {
  logEventSchoolExplorer('08', data);
}

export function logEventSchoolExplorerDisclaimer() {
  logEventSchoolExplorer('09');
}

export function logEventSchoolExplorerComplete(data) {
  logEventSchoolExplorer('10', data);
}

export function logEventSchoolExplorerFeedbackStart() {
  logEventSchoolExplorer('11');
}

export function logEventSchoolExplorerFeedbackStep1(data) {
  logEventSchoolExplorer('12', data);
}

export function logEventSchoolExplorerFeedbackStep2(data) {
  logEventSchoolExplorer('13', data);
}

export function logEventSchoolExplorerFeedbackStep3(data) {
  logEventSchoolExplorer('14', data);
}

export function logEventSchoolExplorerFeedbackStep4(data) {
  logEventSchoolExplorer('15', data);
}

export function logEventSchoolExplorerFeedbackStep5(data) {
  logEventSchoolExplorer('16', data);
}

export function logEventSchoolExplorerFeedbackComplete() {
  logEventSchoolExplorer('17');
}
